import { Button } from '@dru/ui';
import { useAuth } from '../lib/auth';
import { AuthFrame } from './AuthFrame';

/**
 * Signed in, and no console answers to this account's permissions.
 *
 * Reached when a role exists that no console claims — a new platform role
 * before its screens, or a customer's own role with nothing but reads no
 * screen is built around. Says so and offers the one act that always works,
 * instead of landing on somebody else's dashboard and a 403.
 */
export function NoConsole() {
  const { principal, logout } = useAuth();
  return (
    <AuthFrame
      title="No console for this account yet"
      lead={<>You are signed in as <strong>{principal?.email}</strong>, but none of the consoles is open to the role this account holds. Ask your administrator to check the role, then sign in again.</>}
    >
      <Button variant="secondary" className="w-full" onClick={() => logout()}>Sign out</Button>
    </AuthFrame>
  );
}
